import React, { useState, useEffect, useRef } from 'react'
import CloseIcon from '../icons/Close'
import NextIcon from '../icons/Next'
import PreviousIcon from '../icons/Previous'
import WebCamera from './WebCamera/webCam.jsx'

export default (props) => {
    const [title, setTitle] = useState(props.title)
    const [options, setOptions] = useState(props.options)
    const [currentImage, setCurrentImage] = useState(props.currentImage)
    const [currentCaption, setCurrentCaption] = useState(props.currentCaption)
    const [isOpen, setIsOpen] = useState(props.isOpen)
    const [delay, setDelay] = useState(12000)

    // const caption = useRef({
    //     value: ''
    // });
    const caption = useRef(null)

    useEffect(() => {
        if (!props.isOpen) {
            setOptions(props.options)
        }
    }, [props.options])

    useEffect(() => {
        setIsOpen(props.isOpen)
        if (props.isOpen) bindOptions()
    }, [props.isOpen])

    useEffect(() => {
        setTitle(props.title)
        setCurrentImage(props.currentImage)
        setCurrentCaption(props.currentCaption)
        if (props.isOpen) bindOptions()
    }, [props.isOpen, props.title, props.currentImage, props.currentCaption])

    // useEffect(() => {
    //     console.log('open: ', isOpen)
    //     setTitle(props.title)
    //     setOptions(props.options)
    //     setCurrentImage(props.currentImage)
    //     setCurrentCaption(props.currentCaption)
    // }, [isOpen])

    // useEffect(() => {
    //     bindOptions();
    // }, [])

    // useEffect(() => {
    //     if (!props.isOpen) return;

    //     if (props.currentImage)
    //         setCurrentImage(props.currentImage);
    //     // bindOptions();
    // }, [props.currentImage, props.selectedOptions])

    // useEffect(() => {
    //     if (!caption.current || !props.currentCaption) return;

    //     caption.current.value = props.currentCaption;
    //     setCaptionPlaceholder(true);
    // }, [props.currentCaption, caption, caption.current])

    const closeLightbox = (e, bBubble) => {
        if (!bBubble && e.target !== e.currentTarget) return

        props.setIsLightboxOpen(false)
        clearFields()
    }

    const clearFields = () => {
        caption.current.value = ''
        getSelectedOptions().forEach((o) => (o.isSelected = false))
    }

    const handleTakePhoto = (dataUri) => {
        if (dataUri) {
            setCurrentImage(dataUri)
        }
    }

    const handleRetakePhoto = () => {
        setCurrentImage(false)
    }

    const save = () => {
        // if newly-taken, post picture to server
        // otherwise, just update associated fields (options and caption)
        if (currentImage.startsWith('data:')) savePicture()
        else updateFields()

        bindOptions()
    }

    const savePicture = () => {
        props.onAddPicture(currentImage, getSelectedOptions(), caption.current.value)
        caption.current.value = ''
        caption.current.focus()
    }

    const updateFields = () => {
        props.onUpdateFields(props.systemFilename, getSelectedOptions(), caption.current.value)
    }

    const verify = () => {
        if (
            options.length > 0 &&
            getSelectedOptions().length === 0 &&
            caption.current.value === ''
        ) {
            alert('At least 1 option or caption must be provided!')
            return false
        }

        return true
    }

    const handleSaveContinue = () => {
        if (!verify()) return

        if (currentImage) {
            save()
            if (currentImage.startsWith('data:')) {
                setCurrentImage(false)
                setCurrentCaption('')
            } else if (props.gotoNextImage) props.gotoNextImage()
            else props.setIsLightboxOpen(false)
        }
    }

    const handleSaveClose = () => {
        if (!verify()) return

        if (currentImage) {
            save()
        }
        props.setIsLightboxOpen(false)
    }

    // const bindData = () => {
    //     if (props.selectedOptions)
    //         bindOptions();
    //     if (props.currentCaption)
    //         caption.current.value = props.currentCaption;

    //     setCaptionPlaceholder(true);
    // }

    const bindOptions = () => {
        let ops = options.slice()
        ops.forEach((o) => {
            o.isSelected = false
            if (props.selectedOptions) {
                let selectedOption = props.selectedOptions.find((so) => so.Value === o.value)
                if (selectedOption) o.isSelected = true
            }
        })
        setOptions(ops)
    }

    const getSelectedOptions = () => {
        return options.filter((o) => {
            return o.isSelected === true
        })
    }

    const handleOptionChange = (e, op) => {
        let ops = options.slice()

        op.isSelected = e.target.checked

        setOptions(ops)
        setCaptionPlaceholder(op.isSelected === true || getSelectedOptions().length > 0)
    }

    const setCaptionPlaceholder = (bOptionSelected) => {
        caption.current.placeholder = 'Caption...'
        if (bOptionSelected) caption.current.placeholder += ' (Optional)'
    }

    const handleError = (err) =>
        console.error(`ImageGallery.jsx --> Lightbox.jsx --> handleError ${err}`)

    const onClickImage = () => {
        const backdrop = document.getElementById('lightboxBackdrop')
        if (backdrop) backdrop.click()
    }

    const renderOptionList = () => {
        return options.map((o, i) => {
            let id = `${Math.random().toString(36).substring(7)}_${i}`
            return (
                <div
                    key={id}
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                        width:
                            i === options.length - 1 && options.length % 2 === 1 ? '100%' : '50%',
                    }}
                >
                    <input
                        id={`cb_${id}`}
                        type="checkbox"
                        // defaultChecked={props.selectedOptions && !!props.selectedOptions.find(so => so.Value === o.value)}
                        checked={o.isSelected}
                        onChange={(e) => handleOptionChange(e, o)}
                        value={o.value}
                    />
                    <label
                        htmlFor={`cb_${id}`}
                        style={{
                            display: 'inline-block',
                            fontWeight: '500',
                            marginLeft: '15px',
                            whiteSpace: 'normal',
                        }}
                    >
                        {o.text}
                    </label>
                </div>
            )
        })
    }

    const renderCaptionTextArea = () => {
        return (
            <textarea
                ref={caption}
                // ref={ref => {
                //     if (ref)
                //         caption.current = ref
                // }}
                // ref={ref => {
                //     if (ref) {
                //         caption.current = ref
                //         caption.current.value = ref.value
                //     }
                // }}
                // onClick={e => {
                //     e.stopPropagation();
                //     e.preventDefault();
                // }}
                // onChange={e => {
                //     caption.current =  e.target
                // }}
                // onChange={e => {
                //     caption.current = {
                //         target: e.target,
                //         value: e.target.value
                //     }
                // }}
                style={{
                    height: '48px',
                    marginTop: '10px',
                    width: '100%',
                }}
                placeholder={`Caption...${options.length === 0 || getSelectedOptions().length > 0 ? ' (Optional)' : ''
                }`}
                type="text"
                maxLength={500}
                value={currentCaption}
                onChange={(e) => setCurrentCaption(e.target.value)}
            ></textarea>
        )
    }

    return (
        <>
            {isOpen && (
                <div className="veil lightboxVeil" onClick={(e) => closeLightbox(e, false)}>
                    <div
                        onClick={(e) => closeLightbox(e, false)}
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: '#676767',
                                display: 'inline-block',
                                maxWidth: '600px',
                                padding: '15px 20px 20px',
                                width: '100%',
                            }}
                        >
                            <div
                                style={{
                                    marginBottom: '5px',
                                    maxWidth: '600px',
                                    textAlign: 'right',
                                }}
                            >
                                {title !== '' && (
                                    <div
                                        style={{
                                            marginTop: '5px',
                                            border: '1px #484848 solid',
                                            color: 'white',
                                            textTransform: 'uppercase',
                                            fontSize: '0.9em',
                                            padding: '5px',
                                            display: 'inline-block',
                                            width: 'calc(100% - 30px)',
                                            textAlign: 'center',
                                            marginRight: 10,
                                        }}
                                    >
                                        {title}
                                    </div>
                                )}

                                <div
                                    onClick={(e) => closeLightbox(e, true)}
                                    style={{
                                        color: 'white',
                                        display: 'inline-block',
                                        height: '20px',
                                        width: '20px',
                                        textAlign: 'center',
                                        verticalAlign: 'middle',
                                        fontSize: '25px',
                                        cursor: 'pointer',
                                        position: 'relative',
                                    }}
                                >
                                    <CloseIcon
                                        style={{
                                            position: 'absolute',
                                            top: '0',
                                            left: '0',
                                        }}
                                    />
                                </div>
                            </div>
                            <div
                                style={{
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    maxWidth: '600px',
                                    textAlign: 'center',
                                    width: '100%',
                                }}
                            >
                                {currentImage ? (
                                    <div style={{ position: 'relative' }}>
                                        <img
                                            src={currentImage}
                                            style={{
                                                maxHeight: '460px',
                                                maxWidth: '460px',
                                            }}
                                            draggable={false}
                                        />
                                        {currentImage.startsWith('data:') && (
                                            <button
                                                className="btn btn-sm btn-outline-primary"
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '10px',
                                                    left: 'calc(50% - 40px)',
                                                }}
                                                type="button"
                                                onClick={handleRetakePhoto}
                                                title="Re-take picture"
                                            >
                                                <span className="glyphicon glyphicon-refresh" />
                                                &nbsp;Re-take
                                            </button>
                                        )}
                                    </div>
                                ) : (
                                    <WebCamera
                                        style={{
                                            margin: 'auto',
                                            maxWidth: '600px',
                                            width: '100%',
                                        }}
                                        delay={delay}
                                        onError={handleError}
                                        onTakePhoto={handleTakePhoto}
                                        showViewFinder={false}
                                        resolution={1000}
                                    />
                                )}

                                {options.length > 0 && (
                                    <div style={{ padding: '10px 30px 0px 30px' }}>
                                        {renderOptionList()}
                                    </div>
                                )}
                                <div>{renderCaptionTextArea()}</div>
                                <div
                                    style={{
                                        marginTop: '10px',
                                        textAlign: 'center',
                                    }}
                                >
                                    <button
                                        className="btn btn-sm btn-light"
                                        style={{
                                            marginRight: '50px',
                                        }}
                                        type="button"
                                        title={
                                            !props.disabled && !currentImage
                                                ? 'Please take a picture before saving'
                                                : ''
                                        }
                                        disabled={props.disabled || !currentImage}
                                        onClick={
                                            props.disabled || !currentImage
                                                ? null
                                                : handleSaveContinue
                                        }
                                    >
                                        <span className="glyphicon glyphicon-plus" />
                                        &nbsp;Save and Continue
                                    </button>
                                    <button
                                        className="btn btn-sm btn-light"
                                        type="button"
                                        title={
                                            !props.disabled && !currentImage
                                                ? 'Please take a picture before saving'
                                                : ''
                                        }
                                        disabled={props.disabled || !currentImage}
                                        onClick={
                                            props.disabled || !currentImage ? null : handleSaveClose
                                        }
                                    >
                                        <span className="glyphicon glyphicon-remove" />
                                        &nbsp;Save and Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {props.gotoPreviousImage &&
                        currentImage &&
                        !currentImage.startsWith('data:') && (
                        <button
                            type="button"
                            onClick={props.gotoPreviousImage}
                            className="next-prev prev"
                        >
                            <PreviousIcon />
                        </button>
                    )}
                    {props.gotoNextImage && currentImage && !currentImage.startsWith('data:') && (
                        <button
                            type="button"
                            onClick={props.gotoNextImage}
                            className="next-prev next"
                        >
                            <NextIcon />
                        </button>
                    )}
                </div>
            )}
        </>
    )
}
